/**
 * Essa função foi desenvolvida para validar o array de cores atual do gráfico
 * após uma cor ter sido alterada. O que ocorre é que quando uma cor de um gráfico é alterada
 * e esse gráfico possui mais alternativas que a quantidade de cores do tema padrão da aplicação
 * o novo array de cores do gráfico possuirá valores vazios (empty x {slots}).
 *
 * Sendo assim, este método resolve o problema realocando as posições vazias com as cores default
 * do tema da aplicação, de modo cíclico.
 */
export function chartThemeValidator(themeColors, dataLength) {
  if (!Array.isArray(themeColors)) {
    return [];
  }

  const colors = [...themeColors];

  if (dataLength > colors.length) {
    const themeColorsLength = colors.length;
    const dif = dataLength - themeColorsLength;
    for (let i = 0; i < dif; i += 1) {
      colors[themeColorsLength + i] = colors[i % themeColorsLength];
    }
  }

  return colors;
}
